export default "__VITE_ASSET__ad9c5484__"